import styled from 'styled-components';

export const ElidedPath = styled.span`
  display: block;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ElidedTagPath = styled(ElidedPath)`
  ${({ theme }) => theme.typography.p8};
`;

// Tag drops an incoming className, so the chip is reached through its own class.
export const GroupPathContainer = styled.div`
  display: flex;
  min-width: 0;
  max-width: 100%;

  & .custom-tag {
    max-width: 100%;
  }

  /* The chip clips its own label, which would clip before the text inside it
     and leave that text measuring no overflow. */
  & .custom-tag > span {
    min-width: 0;
    overflow: visible;
  }
`;
